import { render, staticRenderFns } from "./InquiryAndAttendance.vue?vue&type=template&id=5e242fcb&scoped=true&"
import script from "./InquiryAndAttendance.vue?vue&type=script&lang=js&"
export * from "./InquiryAndAttendance.vue?vue&type=script&lang=js&"
import style0 from "./InquiryAndAttendance.vue?vue&type=style&index=0&id=5e242fcb&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e242fcb",
  null
  
)

export default component.exports